import { ConsultaSeguimentoFieldModel } from './consulta-seguimento/model-consultaSeguimento'
import { MChatAnteriorFooterInfoModel, MChatFieldModel } from './mchat/model-mchat'

export interface MChatRfFieldModel {
  mchat: MChatFieldModel
  consultaSeguimento: ConsultaSeguimentoFieldModel
}

export interface MChatRfViewModel {
  mchat: MChatFieldModel & MChatAnteriorFooterInfoModel
  consultaSeguimento: ConsultaSeguimentoFieldModel & MChatAnteriorFooterInfoModel
}

export enum MChatRfAccordionSectionEnum {
  MCHAT = 'MCHAT',
  CONSULTA_SEGUIMENTO = 'CONSULTA_SEGUIMENTO',
}

export const MCHAT_RF_ACCORDION_SECTIONS = (
  M_CHAT_RF_ENABLED: boolean
): Record<MChatRfAccordionSectionEnum, { title: string; description: string }> => ({
  MCHAT: {
    title: 'M-CHAT-R™',
    description: 'Aplicação a partir dos 16 meses até 30 meses.',
  },
  CONSULTA_SEGUIMENTO: {
    title: 'Entrevista de seguimento',
    description: `A entrevista de seguimento é recomendada para resultados dentro do Risco Médio no M-CHAT-R.${
      !M_CHAT_RF_ENABLED ? ' Acesse o documento original para aplicar a avaliação.' : ''
    }`,
  },
})
